"use client";
import React from "react";
import InsightsLeft from "./InsightsLeft";
import InsightsBottom from "./InsightsBottom";

const Insights = () => {
  return (
    <div className="m-4">
      <p className="mb-4 font-bold text-2xl">Insights</p>
      <div className="flex gap-4">
        <InsightsLeft />
        <div className="flex flex-col gap-4">
          <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[393px] h-[295px] rounded-lg">
            <p className="text-sm text-[#333333] font-semibold mb-2">
              Credit ratings
            </p>
            <div className="w-[361px] h-[134px] rounded-lg p-4 gap-2 bg-[#EAF4EC]">
              <p className="text-xs font-medium text-[#000000] mb-2">
                Key strengths
              </p>
              <li className="text-xs font-medium text-[#555555]">
                High systemic importance as a D-SIB (domestic systematically
                important bank)
              </li>
              <li className="text-xs font-medium text-[#555555]">
                Strong market position as the largest private sector bank in
                India
              </li>{" "}
              <li className="text-xs font-medium text-[#555555]">
                Healthy capitalization levels
              </li>
            </div>
            <div className="w-[361px] h-[92px] rounded-lg p-4 gap-2 mt-3  bg-[#F4EAEA]">
              <p className="text-xs font-medium text-[#000000] mb-2">
                Negative factors
              </p>
              <li className="text-xs font-medium text-[#555555]">
                Moderation in net interest margin (NIM) post-merger
              </li>
              <li className="text-xs font-medium text-[#555555]">
                Expected continuation of moderation in NIM in the near to medium
                term{" "}
              </li>{" "}
            </div>
          </div>
          <div className="border border-solid border-[#E0E0E0] p-4 gap-4 w-[393px] h-[156px] rounded-lg">
            <p className="text-sm text-[#333333] font-semibold mb-2">
              Corporate actions
            </p>
            <p className="text-sm font-medium text-[#8B8B8B]">
              On May 3, 2024, HDFC Bank allotted 1529461 equity shares to its
              employees under the Employees Stock Options Scheme (ESOS). This
              increased the bank's paid-up share capital from Rs. 7601604788 to
              Rs. 7603134249.
            </p>
          </div>
        </div>
      </div>
      <InsightsBottom />
    </div>
  );
};

export default Insights;
